export const resetFieldValue = (setFieldValue, fields) => {
  fields.forEach((field) => {
    setFieldValue(field, "");
  });
};
